import React from 'react';
import { Card, Row, Col, Form, Button } from 'react-bootstrap';
import MaskedInput from 'react-text-mask';
import { MASK_DATE } from '~/constant';

const PainelModosCalculo = ({ modoCalculo, onModoChange, onSimular, loading }) => {
  const set = (field, value) => onModoChange((prev) => ({ ...prev, [field]: value }));

  return (
    <Card className="mb-2">
      <Card.Header className="py-1">
        <strong>Modos de Cálculo</strong>
      </Card.Header>
      <Card.Body>
        <Row className="align-items-end">
          <Col md={2}>
            <Form.Group>
              <Form.Label className="small mb-1">Qtde Meses</Form.Label>
              <Form.Control
                type="number"
                min={0}
                value={modoCalculo.qtdeMeses}
                onChange={(e) => set('qtdeMeses', e.target.value)}
                disabled={loading}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label className="small mb-1">Dia do Mês</Form.Label>
              <Form.Control
                type="number"
                min={1}
                max={31}
                value={modoCalculo.diaDoMes}
                onChange={(e) => set('diaDoMes', e.target.value)}
                disabled={loading}
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label className="small mb-1">Data Fixa (dd/mm/aaaa)</Form.Label>
              <MaskedInput
                mask={MASK_DATE}
                guide={false}
                type="tel"
                className="form-control"
                placeholder="dd/mm/aaaa"
                value={modoCalculo.dataFixa}
                onChange={(e) => set('dataFixa', e.target.value)}
                disabled={loading}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label className="small mb-1">&nbsp;</Form.Label>
              <Button onClick={onSimular} disabled={loading} variant="info" block>
                Simular
              </Button>
            </Form.Group>
          </Col>
        </Row>
        <small className="text-muted">
          Preencha ao menos um modo. Qtde Meses e Dia do Mês podem ser combinados.
        </small>
      </Card.Body>
    </Card>
  );
};

export default PainelModosCalculo;
